import containerItem from "../type/item/container.js";
import basePage from "./basePage.js";
const home_page = class extends basePage {
    _ImageSlideDelay = 5;
    Background = [];//list class containerItem
    Image = [];//list class containerItem
    NextImageButton = [];//list class containerItem
    PrevImageButton = [];//list class containerItem
    StartButton = [];//list class containerItem
    Foreground = [];//list class containerItem
    Name = "Accueil";
    constructor(args = {}) {
        super(args);
        this.ImageSlideDelay = args.imageSlideDelay ? args.imageSlideDelay : 5;
        this.Background = args.background ? args.background : [];
        this.Image = args.image ? args.image : [];
        this.NextImageButton = args.nextImageButton ? args.nextImageButton : [];
        this.PrevImageButton = args.prevImageButton ? args.prevImageButton : args.previousImageButton ? args.previousImageButton : [];
        this.StartButton = args.startButton ? args.startButton : [];
        this.Foreground = args.foreground ? args.foreground : [];
    }
    set ImageSlideDelay(value) {
        if (value <= 0 || !value)
            value = 1;
        this._ImageSlideDelay = value;
    }
    get ImageSlideDelay() {
        return this._ImageSlideDelay;
    }
    checkIsComplete(result = {isComplete: true, requiredBeforeSave: false, missingElements: []}) {
        result = super.checkIsComplete(result);
        if (this.StartButton.length == 0) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push(`Page: ${this.Name} - Bouton démarrer`);
        }
        return result;
    }
    static variableOfInstance() {
        return [
            {property: "Background", construct: containerItem, jsType: "Array"},
            { property: "Image", construct: containerItem, jsType: "Array"},
            {property: "ImageSlideDelay", construct: Number, jsType: "Number"},
            {property: "NextImageButton", construct: containerItem, jsType: "Array"},
            { property: "PrevImageButton", construct: containerItem, jsType: "Array"},
            {property: "StartButton", construct: containerItem, jsType: "Array"},
            ...super.variableOfInstance(),
            {property: "Foreground", construct: containerItem, jsType: "Array"},
        ];
    }
    getPropertiesDescription() {
        return [
            ...super.getPropertiesDescription(),
            { name: "ImageSlideDelay", text: "Temps d'image du carrouselle", description: "Temps entre chaque image de l'élément Diaporama", objectType: "Number", jsType: "Number", constructor: Number },
            { iconSVG: "backgroundIcon", name: "Background", text: "Fond", description: "Éléments de fond de la page", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            {
                maxElement: 1, iconSVG: "imageCarouselIcon", name: "Image", text: "Carouselle des photos", description: "Diaporama des images effectuées", objectType: "containerItem", jsType: "Array", constructor: containerItem,
                multipleConstructorParameter: [
                    { canBeCopied: false, contents: [{ objectType: "DynamicImage", canBeRemove: false, name: "Prise précédant", id: "SLIDER"}]},
                ]
            },
            { iconSVG: "nextIcon", name: "NextImageButton", text: "Bouton photo suivant", description: "Bouton pour passer à l'image suivante du diaporama", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { iconSVG: "backIcon", name: "PrevImageButton", text: "Bouton photo précédent", description: "Bouton pour revenir à l'image précédente du diaporama", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { iconSVG: "validateIcon", name: "StartButton", text: "Bouton démarrer", description: "Bouton pour démarrer la prise de vue", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { iconSVG: "backgroundIcon", name: "Foreground", text: "Avant plan", description: "Éléments en avant plan de la page", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
        ]
    }
}
export default home_page;
